import { render } from "./CreateReceipt.vue?vue&type=template&id=2a7c5faa&scoped=true"
import script from "./CreateReceipt.vue?vue&type=script&lang=js"
export * from "./CreateReceipt.vue?vue&type=script&lang=js"

import "./CreateReceipt.vue?vue&type=style&index=0&id=2a7c5faa&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7c5faa"]])

export default __exports__